const FilterLines = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.875 5C1.875 4.65482 2.15482 4.375 2.5 4.375H17.5C17.8452 4.375 18.125 4.65482 18.125 5C18.125 5.34518 17.8452 5.625 17.5 5.625H2.5C2.15482 5.625 1.875 5.34518 1.875 5ZM4.375 10C4.375 9.65482 4.65482 9.375 5 9.375H15C15.3452 9.375 15.625 9.65482 15.625 10C15.625 10.3452 15.3452 10.625 15 10.625H5C4.65482 10.625 4.375 10.3452 4.375 10ZM6.875 15C6.875 14.6548 7.15482 14.375 7.5 14.375H12.5C12.8452 14.375 13.125 14.6548 13.125 15C13.125 15.3452 12.8452 15.625 12.5 15.625H7.5C7.15482 15.625 6.875 15.3452 6.875 15Z"
        fill="#1F1F1F"
      />
    </svg>
  );
};

export default FilterLines;
